import { useQuery } from '@apollo/client/react';
import { MY_VENDOR_CATALOG_SEARCH } from 'api/graphql/catalog';
import { useVendor } from 'features/vendor';

const MIN_QUERY_LENGTH = 2;
const RESULT_LIMIT = 15;

/** Searches the vendor's catalog for a `query` (skips very short queries). */
export function useCatalogSearch(query) {
  const { vendorId } = useVendor();
  const trimmed = (query || '').trim();

  const { data, loading } = useQuery(MY_VENDOR_CATALOG_SEARCH, {
    variables: { vendorId, search: { searchQuery: trimmed, limit: RESULT_LIMIT } },
    skip: !vendorId || trimmed.length < MIN_QUERY_LENGTH,
    fetchPolicy: 'no-cache',
  });

  return {
    results: data?.myVendorCatalog?.items ?? [],
    loading,
    enabled: trimmed.length >= MIN_QUERY_LENGTH,
  };
}
